// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"d34137b764a64abf3950","293":"aeffb61f6ff0165d8e2c","518":"d1c2d419ebdc18744639","779":"87e424470c54e92ce3b9"}[chunkId] + ".js";
};